(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vueVconsoleDevtools", [], factory);
	else if(typeof exports === 'object')
		exports["vueVconsoleDevtools"] = factory();
	else
		root["vueVconsoleDevtools"] = factory();
})(this, function() {
return 